<template>
  <div class="autocomplete">
    <input
      type="text"
      v-model="search"
      @input="onChange"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      @keydown.enter="onEnter"
    />
    <ul v-show="isOpen" class="autocomplete-results" ref="scroller">
      <li
        v-for="(item, i) in results"
        :key="i"
        @click="setResult(item)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        {{ item.nama }} ({{ item.harga_beli | number }} / {{ item.satuan }})
      </li>
      <li v-show="results.length <= 0">
        <p class="not-found">
          Barang tidak ditemukan <router-link to="/master/bahan-baku">(Input barang baru)</router-link>
        </p>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: "Autocomplete",
  data() {
    return {
      search: this.nama,
      results: [],
      isOpen: false,
      arrowCounter: -1,
    };
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    nama: {
      type: String,
      required: false,
      default: "",
    },
    clearOnEnter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    filterResults() {
      this.results = this.items.filter(
        (item) =>
          item.nama.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      );
    },
    onChange() {
      this.$emit("input", this.search);
      this.filterResults();
      this.isOpen = true;

      // if (this.results.length > 0) {
      //   this.isOpen = true;
      // } else {
      //   this.isOpen = false;
      // }
    },
    setResult(result) {
      this.search = result.nama;
      this.arrowCounter = -1;
      this.isOpen = false;

      this.$emit("selected", result);
      
      if (this.clearOnEnter) {
        this.search = "";
      }
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.arrowCounter = -1;
        this.isOpen = false;
      }
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length - 1) {
        this.arrowCounter = this.arrowCounter + 1;
        if (this.arrowCounter > 3) {
          this.$refs['scroller'].scrollTop = (37.5 * this.arrowCounter);
        }
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.$refs['scroller'].scrollTop = 37.5 * this.arrowCounter;
      }
    },
    onEnter() {
      const item = this.results[this.arrowCounter];
      if (item) {
        this.search = item.nama;
        this.arrowCounter = -1;
        this.isOpen = false;
        this.$emit("selected", item);

        if (this.clearOnEnter) {
          this.search = "";
        }
      } else {
        this.$emit("selectedEmpty");
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>
<style lang="scss" scoped>
.autocomplete {
  position: relative;
  .autocomplete-results {
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    margin: 5px 0;
    padding: 0;
    list-style-type: none;
    border-radius: 5px;
    width: 100%;
    max-height: 150px;
    overflow: auto;
    z-index: 2;
    .autocomplete-result {
      padding: 10px;
      font-size: 14px;
      &.is-active,
      &:hover {
        background-color: var(--primary);
        color: #fff;
      }
    }

    .not-found {
      text-align: center;
      a {
        text-decoration: none;
        color: var(--primary);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/custom/Autocomplete.vue